import { Link, type LinkProps } from '@tanstack/react-router';
import { ArrowLeft } from '@phosphor-icons/react';
import { Icon } from '../Icon';

export interface BackLinkProps {
  to: LinkProps['to'];
  children: string;
}

/** "‹ Back to sign in" style link above a form (Figma Label/Medium, secondary text). */
export function BackLink({ to, children }: BackLinkProps) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-(--mbm-space-1-5) self-start text-label-medium text-text-secondary hover:text-text-primary focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring) rounded-(--mbm-radius-xs)"
    >
      <Icon icon={ArrowLeft} size="sm" />
      {children}
    </Link>
  );
}
